import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCPE2sQpLWeAAONryqW7GjCg2m1C4QqEsI",
  authDomain: "pointshub-517bd.firebaseapp.com",
  projectId: "pointshub-517bd",
  storageBucket: "pointshub-517bd.firebasestorage.app",
  messagingSenderId: "806902896313",
  appId: "1:806902896313:web:350b7f20e23ac393476d68"
};

const app = initializeApp(firebaseConfig);
const secondaryApp = initializeApp(firebaseConfig, "Secondary");

export const auth = getAuth(app);
export const secondaryAuth = getAuth(secondaryApp);
export const db = getFirestore(app);